// 	export default  [
// xs	<768px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// sm	≥768px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// md	≥992px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// lg	≥1200px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// xl	≥1920px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})
// // ]

export default [
	{ label:'药品名称：',xs:12,sm:12,md:7,lg:8,xl:8,type:'selectName',modelValue:'drugId',prop:'drugId', op:'nameOption'},
	{ label:'规格描述：',xs:12,sm:12,md:7,lg:8,xl:8,type:'input',modelValue:'drugspec',prop:'drugspec', op:'selectOption'},
	// { label:'加成方式：',xs:12,sm:12,md:7,lg:4,xl:4,type:'select',modelValue:'markUpId',prop:'markUpId', op:'MarkOption',disabled:true},
	{ label:'批准文号：',xs:12,sm:12,md:6,lg:8,xl:8,type:'input',modelValue:'approvalNumber',prop:'approvalNumber', disabled:true},
	
	{ label:'入库数量：',  xs:12,sm:12,md:10,lg:10,xl:10,type:'inputNum',modelValue:'purcCnt',prop:'purcCnt',placeholder:''},
	// { label:'采购类别：',xs:12,sm:12,md:6,lg:5,xl:5,type:'select',modelValue:'cglb',prop:'cglb', op:'cgOption'},
	{ label:'生产厂家：',xs:12,sm:12,md:8,lg:8,xl:8,type:'selectProdent',modelValue:'prodentpName',prop:'prodentpName',op:'prodentOption',disabled:true},
	// { label:'',         xs:12,sm:12,md:6,lg:6,xl:6,type:'tag',modelValue:'markUp',prop:'markUp',placeholder:'markUp'},
	
	{ label:'生产批号：',     xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'manuLotnum',prop:'manuLotnum',placeholder:''},
	{ label:'成本单价：',     xs:12,sm:12,md:5,lg:5,xl:5,type:'input',modelValue:'purcPric',prop:'purcPric',placeholder:''},
	{ label:'小单位成本单价：',xs:12,sm:12,md:4,lg:4,xl:4,type:'input',modelValue:'minPurcPric',prop:'minPurcPric' },
	{ label:'销售单价：',     xs:12,sm:12,md:5,lg:5,xl:5,type:'input',modelValue:'salePric',prop:'salePric',placeholder:''},
	{ label:'小单位销售单价：',xs:12,sm:12,md:4,lg:4,xl:4,type:'input',modelValue:'minSalePric',prop:'minSalePric',placeholder:''},
	// { label:'',xs:3,sm:3,md:3,lg:3,xl:3,type:'input',modelValue:'numZ', disabled:'true'},
	
	{ label:'大单位成本单价：',xs:12,sm:12,md:6,lg:4,xl:4,type:'input',modelValue:'maxPurcPric',prop:'maxPurcPric'},
	{ label:'大单位销售单价：',xs:12,sm:12,md:6,lg:4,xl:4,type:'input',modelValue:'maxSalePric',prop:'maxSalePric'},
	{ label:'生产日期：',  xs:12,sm:12,md:12,lg:6,xl:6,type:'date',modelValue:'manuDate',prop:'manuDate'},
	{ label:'有效日期：',  xs:12,sm:12,md:12,lg:6,xl:6,type:'date',modelValue:'expyDate',prop:'expyDate',placeholder:''},
	
	{ label:'加入'        ,xs:24,sm:24,md:24,lg:4,xl:4,type:'btn',modelValue:'join',disabled:false },
]

